import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isolateMixin } from '../utils/mixins';
import { withStyles } from '../theme';
import ClearIcon from './ClearIcon';
var iconStyle = {
  fill: null
};

var styles = function styles(_ref) {
  var tagsInput = _ref.tagsInput;
  return _extends({
    root: {
      extend: isolateMixin,
      display: 'inline-flex',
      fontSize: tagsInput.fontSize,
      whiteSpace: 'nowrap',
      pointerEvents: 'none',
      transition: 'background-color .2s'
    },
    icon: {
      alignSelf: 'center',
      fill: 'currentColor',
      transition: 'fill .2s, color .2s'
    },
    text: {
      flex: '0 1 auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      transition: 'color .2s'
    },
    remove: {
      order: 1,
      flex: 'none',
      fontSize: 15,
      width: '1em',
      height: '1em',
      alignSelf: 'center',
      pointerEvents: 'auto',
      transition: 'fill .2s'
    },
    isClickable: {
      pointerEvents: 'auto'
    },
    isEnabled: {
      '&$isClickable, & $remove': {
        cursor: 'pointer'
      }
    },
    isDisabled: {
      '&$isClickable, & $remove': {
        cursor: 'not-allowed'
      }
    }
  }, ['regular', 'background'].reduce(function (result, type) {
    var typeTheme = tagsInput.types[type];
    var height = typeTheme.height,
        colors = typeTheme.colors;
    return _extends({}, result, _defineProperty({}, type, {
      borderRadius: typeTheme.borderRadius,
      lineHeight: "".concat(height, "px"),
      '& $icon': {
        marginLeft: typeTheme.iconLeftMargin,
        marginRight: typeTheme.iconRightMargin
      },
      '& $remove': {
        marginLeft: typeTheme.removeLeftMargin,
        marginRight: typeTheme.removeRightMargin
      },
      '& $text': {
        marginLeft: typeTheme.paddingLeft,
        marginRight: typeTheme.paddingRight
      },
      '& $icon + $text': {
        marginLeft: 0
      },
      '& $remove ~ $text': {
        marginRight: 0
      },
      '&$isEnabled': {
        color: colors.default.text,
        background: colors.default.background,
        '&$isClickable': {
          '&:hover': {
            background: colors.hover.background,
            '& $remove:not(:hover) ~ $text, & $text:only-child, & $icon:first-child + $text': {
              color: colors.hover.text
            },
            '& $remove:not(:hover) + $icon, & $icon:first-child': {
              fill: 'currentColor!important',
              color: colors.hover.icon
            }
          },
          '&:active': {
            background: colors.active.background,
            '& $remove:not(:active) ~ $text$text, & $text$text:only-child, & $icon:first-child + $text$text': {
              color: colors.active.text
            },
            '& $remove:not(:active) + $icon$icon, & $icon$icon:first-child': {
              fill: 'currentColor!important',
              color: colors.active.icon
            }
          }
        },
        '& $remove': {
          fill: colors.default.icon,
          '&:hover': {
            fill: colors.hover.icon
          },
          '&:active': {
            fill: colors.active.icon
          }
        }
      },
      '&$isDisabled': {
        color: colors.disabled.text,
        background: colors.disabled.background,
        '& $remove': {
          fill: colors.disabled.icon
        }
      }
    }));
  }, {}));
};

var TagsInputItem = /*#__PURE__*/function (_Component) {
  _inherits(TagsInputItem, _Component);

  var _super = _createSuper(TagsInputItem);

  function TagsInputItem() {
    var _this;

    _classCallCheck(this, TagsInputItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleClick = function (event) {
      var _this$props = _this.props,
          value = _this$props.value,
          onClick = _this$props.onClick;
      onClick(event, value);
    };

    _this.handleRemoveClick = function (event) {
      event.stopPropagation();
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onRemove = _this$props2.onRemove;
      onRemove(event, value);
    };

    _this.handleMouseDown = function (event) {
      event.preventDefault();
    };

    return _this;
  }

  _createClass(TagsInputItem, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          nodeRef = _this$props3.nodeRef,
          children = _this$props3.children,
          icon = _this$props3.icon,
          onClick = _this$props3.onClick,
          onRemove = _this$props3.onRemove,
          classes = _this$props3.classes,
          type = _this$props3.type,
          theme = _this$props3.theme,
          value = _this$props3.value,
          other = _objectWithoutProperties(_this$props3, ["className", "disabled", "nodeRef", "children", "icon", "onClick", "onRemove", "classes", "type", "theme", "value"]);

      return React.createElement("div", _extends({}, other, {
        className: classnames(className, classes.root, classes[type], disabled ? classes.isDisabled : classes.isEnabled, onClick && classes.isClickable),
        onClick: disabled ? undefined : this.handleClick,
        ref: nodeRef
      }), onRemove && React.createElement(ClearIcon, {
        className: classes.remove,
        size: null,
        style: iconStyle,
        onClick: disabled ? undefined : this.handleRemoveClick,
        onMouseDown: disabled ? undefined : this.handleMouseDown,
        role: disabled ? undefined : 'button'
      }), icon && cloneElement(icon, {
        className: classnames(classes.icon, icon.props.className),
        size: theme.tagsInput.types[type].iconSize,
        color: !disabled && icon.props.color || null
      }), React.createElement("span", {
        className: classes.text
      }, children));
    }
  }]);

  return TagsInputItem;
}(Component);

TagsInputItem.defaultProps = {
  type: 'regular'
};
TagsInputItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Дополнительный CSS-класс
   */
  className: PropTypes.string,

  /**
   * Значение тега, по-умолчанию считается, что это примитив
   */
  value: PropTypes.any.isRequired,

  /**
   * Контент тега
   */
  children: PropTypes.string.isRequired,

  /**
   * Иконка
   */
  icon: PropTypes.element,

  /**
   * Коллбек клика на тег, в качестве аргументов принимает объект события и value
   */
  onClick: PropTypes.func,

  /**
   * Коллбек клика на иконку удаления, в качестве аргументов принимает объект события и value (автоматически проставляется компонентом `<TagsInput/>`)
   */
  onRemove: PropTypes.func,

  /**
   * Коллбек для получения ссылки на элемент, принимает ref в качестве аргумента (автоматически проставляется компонентом `<TagsInput/>`)
   */
  nodeRef: PropTypes.func,

  /**
   * Отключить элемент (автоматически проставляется компонентом `<TagsInput/>`)
   */
  disabled: PropTypes.bool,

  /**
   * Разновидность тега (автоматически проставляется компонентом `<TagsInput/>`)
   */
  type: PropTypes.oneOf(['regular', 'background'])
} : {};
export default withStyles(styles, {
  name: 'TagsInputItem'
})(TagsInputItem);